const lazyUsersCasesPageComponent = () => import('@/Pages/En/UsersCases/UsersCases.vue');
const lazyCasePageComponent = () => import('@/Pages/En/UsersCases/CasePage.vue');

export const usersCasesRoutes = [
    {
        path: '/users-cases',
        pathname: '/users-cases',
        name: 'users-cases',
        component: lazyUsersCasesPageComponent,
        meta: {
        name: 'users-cases',
        title: 'Users Cases',
        },
    },
    {
        path: '/users-cases/:slug',
        pathname: '/users-cases/:slug',
        name: 'case-page',
        component: lazyCasePageComponent,
        meta: {
        name: 'case-page',
        title: 'Users Cases',
        },
    },
];
